import { createPortal } from "react-dom";
import { Toaster } from "react-hot-toast";
import { twJoin } from "tailwind-merge";

import { DEFAULT_TOAST_DURATION_MS } from "src/design-system/Toast/constants";
import { useIsMainSidebarExpanded } from "src/mainPage/mainSidebarStore";

export const AppToaster: React.FC = () => {
  // Based on the sidebar collapsed state, we set
  // different margin classes for the toaster.
  const isExpanded = useIsMainSidebarExpanded();

  return createPortal(
    <Toaster
      containerClassName={twJoin("mb-12", isExpanded ? "ml-60" : "ml-14")}
      position="bottom-left"
      toastOptions={{
        duration: DEFAULT_TOAST_DURATION_MS,
        position: "bottom-left",
      }}
    />,
    document.body,
  );
};
